import { useMemo, useState } from 'react'
import { Apple, ArrowRight, Download, Loader2, Monitor } from 'lucide-react'

function Ad2345DownloadButtons({ theme = 'rose' }) {
  const [downloading, setDownloading] = useState(null)

  const palette = useMemo(() => {
    const map = {
      rose: {
        card: 'border-rose-100 bg-white hover:border-rose-300 hover:shadow-[0_24px_60px_-30px_rgba(244,63,94,0.28)]',
        icon: 'bg-rose-50 text-rose-600',
        button: 'border-rose-200 bg-rose-50 text-rose-700 hover:bg-rose-100'
      },
      cyan: {
        card: 'border-cyan-100 bg-white hover:border-cyan-300 hover:shadow-[0_24px_60px_-30px_rgba(34,211,238,0.45)]',
        icon: 'bg-cyan-50 text-cyan-600',
        button: 'border-cyan-200 bg-cyan-50 text-cyan-700 hover:bg-cyan-100'
      }
    }
    return map[theme] || map.rose
  }, [theme])

  const items = [
    {
      id: 'windows',
      label: 'Windows 版本',
      helper: '下载安装包后按提示完成安装',
      icon: Monitor
    },
    {
      id: 'macos-intel',
      label: 'Mac Intel 版本',
      helper: '适合 Intel 芯片 Mac 设备',
      icon: Apple
    },
    {
      id: 'macos-apple',
      label: 'Mac Apple 版本',
      helper: '适合 Apple Silicon 芯片 Mac 设备',
      icon: Apple
    }
  ]

  const handleDownload = (id) => {
    setDownloading(id)
    window.location.href = `/api/ad2345/download/${encodeURIComponent(id)}`
    window.setTimeout(() => setDownloading(null), 1200)
  }

  return (
    <div className="grid gap-4 md:grid-cols-3">
      {items.map((item) => {
        const Icon = item.icon
        const isBusy = downloading === item.id
        return (
          <button
            key={item.id}
            type="button"
            onClick={() => handleDownload(item.id)}
            disabled={isBusy}
            className={`group rounded-3xl border p-6 text-left text-slate-900 transition duration-300 ${palette.card}`}
          >
            <div className={`mb-5 inline-flex rounded-2xl p-3 ${palette.icon}`}>
              <Icon className="h-6 w-6" />
            </div>
            <div className="mb-2 text-lg font-semibold">{item.label}</div>
            <div className="mb-5 text-sm leading-6 text-slate-500">{item.helper}</div>
            <div className={`inline-flex items-center gap-2 rounded-full border px-4 py-2 text-sm ${palette.button}`}>
              {isBusy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Download className="h-4 w-4" />}
              立即下载
              {!isBusy && <ArrowRight className="h-4 w-4 transition group-hover:translate-x-0.5" />}
            </div>
          </button>
        )
      })}
    </div>
  )
}

export default Ad2345DownloadButtons
